var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.classes,attrs:{"disabled":_vm.itemDisabled}},_vm.$listeners),[_c('span',{class:_vm.$style.text},[_vm._t("text")],2),(_vm.$slots.icon)?_c('span',{class:_vm.$style.icon},[_vm._t("icon")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }